import { FloytOkContent, StageContent } from '../content';
import { StageOfType } from './StageOfType';

export class ModernStage implements StageOfType<'modern', StageContent> {
  type = 'modern' as const;

  constructor(private content: FloytOkContent) {}

  get banderole() {
    return this.content.stage.banderole;
  }

  get headline() {
    return this.content.stage.headline;
  }

  get image() {
    return this.content.stage.image;
  }

  get includeSearch() {
    return this.content.stage.includeSearch;
  }

  get pageTitle() {
    return this.content.stage.pageTitle;
  }

  get partners() {
    return this.content.stage.partners;
  }
}
